module.exports = __webpack_public_path__ + "img/clock-black-icon.d4b2469c.svg";